import { useEffect, useState } from 'react';

import CPDashboardTab from 'components/CPDashboardTab/CPDashboardTab';
import { TabName, TabState } from 'components/CPDashboardTab/types';

import { CPDashboardTabsProps } from './types';

import * as S from './styles';

const CPDashboardTabs: React.FC<CPDashboardTabsProps> = ({
  loading,
  onTabSelected,
  tabsData,
}) => {
  const getTabsData = tabsData.map(({ name, amount, state }) => {
    return {
      name,
      amount,
      state: state || TabState.DISABLED,
    };
  });

  const [tabs, setTabs] = useState(getTabsData);

  const handleTabSelection = (tabName: TabName) => {
    const selectedTab = tabs.find(({ name }) => tabName === name);

    if (selectedTab?.state === TabState.INACTIVE) {
      onTabSelected(tabName);

      const updatedTabs = tabs.map(tab => {
        let updatedTab;

        if (tab.name === tabName) {
          updatedTab = { ...tab, state: TabState.ACTIVE };
        } else if (tab.state === TabState.DISABLED) {
          updatedTab = tab;
        } else {
          updatedTab = { ...tab, state: TabState.INACTIVE };
        }

        return updatedTab;
      });

      setTabs(updatedTabs);
    }
  };

  useEffect(() => {
    if (!loading) {
      setTabs(getTabsData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <S.Wrapper>
      {tabs.map(tab => (
        <CPDashboardTab
          key={tab.name}
          name={tab.name}
          amount={tab.amount}
          onSelect={handleTabSelection}
          state={tab.state}
        />
      ))}
    </S.Wrapper>
  );
};

export default CPDashboardTabs;
